$(document).ready(function(){

    if ($('.network-join').length) {
        
        $(".add-or-select #innovation_id").on('change', function() {

            window.location = "/organisation/"+networkGroupSlug+"/"+slug+"/apply/innovation/vetting/"+$(this).val()+"/create/join";
        });
    }
});